export default "__VITE_PUBLIC_ASSET__6e67c508__"